var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemImage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M20 4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Zm-10 7.414-6 6V18h16v-.586l-3-3-1.293 1.293a1 1 0 0 1-1.414 0zM20 6H4v8.586l5.293-5.293a1 1 0 0 1 1.414 0L15 13.586l1.293-1.293a1 1 0 0 1 1.414 0L20 14.586zm-3 2a1 1 0 1 1 0 2 1 1 0 1 1 0-2"
})));
export default SvgGemImage;